var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidePageView),expression:"!hidePageView"}],attrs:{"id":"cash"}},[_c('div',{staticClass:"cash-box"},[_c('CashHeader'),_c('CashPayway')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }